import React, { useMemo } from 'react';
import styles from './SkillPaths.module.scss';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from '@material-ui/core';
import EmptyStateCard from './EmptyStateCard';
const options = (total) => ({
  plugins: {
    tooltip: {
      enabled: total > 0,
      callbacks: {
        label: function (context) {
          return ` ${context?.label}: ${context?.formattedValue}%`;
        },
      },
    },
    legend: {
      display: false,
    },
  },
  animation: {
    duration: 1,
  },
  maintainAspectRatio: false,
  cutout: '70%',
  radius: '100%',
  cutoutPercentage: 10,
});
const SkillPathChart = ({ title = '', progress = {} }) => {
  const data = useMemo(() => {
    const fetchChartData = (progress) => {
      if (progress?.total) {
        return [
          Math.round((progress?.published * 100) / progress.total),
          Math.round((progress?.drafts * 100) / progress.total),
        ];
      } else {
        return [1];
      }
    };

    const colors = progress?.total === 0 ? ['#e3e3e3'] : ['#0494FD', '#ECEFF1'];

    return {
      labels: ['Published', 'Drafts'],
      datasets: [
        {
          label: '',
          data: fetchChartData(progress),
          backgroundColor: colors,
          borderColor: colors,
          hoverBorderColor: colors,
          hoverBackgroundColor: colors,
          hoverBorderWidth: 0,
          hoverBorderRadius: 0,
          hoverOffset: 6,
          borderWidth: 1,
        },
      ],
    };
  }, [progress]);
  // if (true) return <EmptyStateCard emptyStateText="No Skill Paths" />;

  return (
    <div className={styles.progressChart}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLine1}>
          <span className={styles.headerPeriod}>Total</span>
          <span className={styles.headerPeriod}>In the last year</span>
        </div>
        <span className={styles.headerTitle}>{title}</span>
      </div>
      <div className={styles.bodyChart}>
        <Grid item xs={12} md={12} className={styles.chartDatasets}>
          <ul className="listUnstyled">
            <li className={styles.published}>
              Published - <strong>{progress?.published}</strong>
            </li>
            <li className={styles.drafts}>
              Drafts - <strong>{progress?.drafts}</strong>
            </li>
          </ul>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          style={{ height: '200px', position: 'relative', marginTop: '1.5rem' }}
        >
          <div className={styles.totalContainer}>
            <h6 className="heading1">{progress?.total}</h6>
            <p className="paragraph">Total</p>
            <p className="paragraph">Skill Paths</p>
          </div>
          <Doughnut data={data} options={options(progress?.total)} />
        </Grid>
      </div>
    </div>
  );
};

export default SkillPathChart;
